import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '@/config/environment.ts';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: `${environment.apiUrl}/api`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('HlidkainsolvenceToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['User', 'Account', 'MonitoredSubjects', 'SubjectChecks', 'SubjectChanges', 'NotificationContacts', 'Subscriptions', 'BillingAddress', 'AccountUsers', 'Invitations', 'InsolvencyProceedings', 'Dashboard'],
  endpoints: () => ({}),
});
